export function arrayBufferToBase64(buffer) {
  let binary = '';
  let bytes = new Uint8Array(buffer);
  let len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  // btoa converts binary string to base64 encoded string
  return window.btoa(binary);
}
export function base64ToArrayBuffer(base64) {
  let binary_string = window.atob(base64);
  let len = binary_string.length;
  let bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes;
}
// Calculate checksum as per your iOS logic
export function calculateChecksum(data) {
  let sum = 0;
  for (let i = 0; i < data.length; i++) {
    sum += data[i];
  }
  return sum & 0xffff; // Assuming a 16-bit checksum
}
export function getDataType(data) {
  // Check for a specific header pattern that indicates the type
  if (data[0] === 3 && data[1] === 1) {
    return 1; // Assume '1' is a type identifier for this header format
  } else if (
    data[0] === 0x46 &&
    data[1] === 0x4d &&
    data[4] === 0x30 &&
    data[5] === 0x33 &&
    data[6] === 0x30 &&
    data[7] === 0x00
  ) {
    return 2; // Assume '2' is a type identifier for this header format
  } else if (
    data[0] === 0x46 &&
    data[1] === 0x4d &&
    data[4] === 0x20 &&
    data[5] === 0x32 &&
    data[6] === 0x30 &&
    data[7] === 0x00
  ) {
    return 3; // Assume '3' is a type identifier for this header format
  }
  return 0; // No known header format found
}
export function isoToStd(type, data) {
  if (!data || data.length === 0) {
    return;
  }

  let headerType = getDataType(data);
  if (headerType === 2 && type === 1) {
    return isoAToStd(data);
  } else if (headerType === 3 && type === 2) {
    return isoBToStd(data);
  }
}
function isoAToStd(data) {
  const res = new Uint8Array(512); // Adjust size as necessary
  // Assume data starts after a fixed-size header, and minutiae are in specific positions
  const headerSize = 26; // Assuming the header and other data take up the first 26 bytes
  const minutiaCount = data[25]; // Number of minutiae often stored at a specific position
  let index = headerSize;

  for (let i = 0; i < minutiaCount; i++) {
    const x = (data[index] << 8) | data[index + 1];
    const y = (data[index + 2] << 8) | data[index + 3];
    const angle = data[index + 4]; // Angle is usually in degrees
    const type = data[index + 5] & 0xc0; // High 2 bits for type
    const quality = data[index + 5] & 0x3f; // Low 6 bits for quality

    // Write to output in standard format assumed to be x, y, angle, type, quality
    const outputIndex = i * 5;
    res[outputIndex] = x;
    res[outputIndex + 1] = y;
    res[outputIndex + 2] = angle;
    res[outputIndex + 3] = type;
    res[outputIndex + 4] = quality;

    index += 6; // Move to the next minutia data set
  }
  return res;
}

function isoBToStd(pSrc) {
  const res = new Uint8Array(512); // Adjust size as necessary
  let n = 28; // Starting index for minutiae data in the source array
  let count = 0; // Counter for valid minutiae entries
  let info = 0;

  // Initialize header in destination
  res[0] = 3;
  res[1] = 1;
  res[2] = pSrc[26]; // Copying the quality value
  res[3] = pSrc[27]; // Number of minutiae

  // Process each minutia
  for (let i = 0; i < pSrc[27]; i++) {
    let t = (pSrc[n] >> 6) & 0x03;
    let x = ((pSrc[n] & 0x3f) << 8) + pSrc[n + 1];
    let y = ((pSrc[n + 2] & 0x3f) << 8) + pSrc[n + 3];
    let a = pSrc[n + 4];
    let v = pSrc[n + 5];

    if (t === 1 || t === 2) {
      info = 0;
      info |= x << 23;
      info |= y << 14;
      info |= ((360 - (a * 360) / 256) << 5) & 0x1ff;
      info |= ((v * 16) / 100) << 1;
      info |= t - 1;

      res[56 + count * 4 + 0] = (info >>> 24) & 0xff;
      res[56 + count * 4 + 1] = (info >>> 16) & 0xff;
      res[56 + count * 4 + 2] = (info >>> 8) & 0xff;
      res[56 + count * 4 + 3] = info & 0xff;

      count++;
    }
    n += 6;
  }
  res[3] = count; // Set the actual number of processed minutiae
  return res;
}

export const fpToString = (data, type) => {
  return arrayBufferToBase64(data);
};
export const stringToFp = (fpString, type) => {
  if (!fpString) {
    return null;
  }
  return base64ToArrayBuffer(fpString);
};
